import { createThunk, ListModel, model } from 'mst-collection';
import { castToSnapshot, getRoot, types } from 'mobx-state-tree';

import { TrackModel } from './TrackModel';
import { Api, schemas } from '@api';
import { shouldRejectPagination, handleFlow } from '../utils';
import type { RootModelType } from '../RootModel';

export class PopularTrackList extends ListModel(
  types.reference(TrackModel),
  {
    idAttribute: 'id',
    schema: schemas.TrackListSchema,
    pageSize: 30,
  },
) {
  get preview() {
    return this.array.slice(0, 18);
  }

  fetchPreview = createThunk(() => {
    return async function fetch(this: PopularTrackList) {
      // fetch tracks
      const res = await Api.Tracks.getPopularTracks({ count: 18 });

      // fetch users for those tracks and merge users into them
      const tracks = await getRoot<RootModelType>(
        this,
      ).track.fetchUsersAndMerge.run(res.data.tracks);

      this.set(tracks);
    };
  });

  fetch = createThunk(() => {
    return async function fetch(this: PopularTrackList) {
      const res = await Api.Tracks.getPopularTracks({
        count: this.pageSize,
      });

      const tracks = await getRoot<RootModelType>(
        this,
      ).track.fetchUsersAndMerge.run(res.data.tracks);

      this.set(tracks);
    };
  });

  fetchMore = createThunk(() => {
    return async function fetchMore(this: PopularTrackList, flow) {
      if (shouldRejectPagination(this)) {
        return;
      }

      await handleFlow(flow, async () => {
        const res = await Api.Tracks.getPopularTracks({
          count: this.pageSize,
          start: this.offset,
        });

        const tracks = await getRoot<RootModelType>(
          this,
        ).track.fetchUsersAndMerge.run(res.data.tracks);

        this.append(castToSnapshot(tracks));
      });
    };
  }, false);
}

export const PopularTrackListModel = model(PopularTrackList);
